import { parseCookies, setCookie, destroyCookie } from 'nookies'

interface CookieOptionsType {
  expires?: number
  path?: string
  domain?: string
  secure?: boolean
  httpOnly?: boolean
  maxAge?: number
  sameSite?: 'Strict' | 'Lax' | 'None'
}

const get =
  (_domain: string, prefix: string) =>
  (key: string): string => {
    const cookies = parseCookies()
    return cookies[`${prefix}-${key}`]
  }

const set =
  (domain: string, prefix: string) =>
  (key: string, value: string, options?: CookieOptionsType) => {
    setCookie(null, `${prefix}-${key}`, value, {
      maxAge: options?.maxAge || 60 * 60 * 24 * 90, // 90 days
      path: '/',
      domain,
      secure: true,
      httpOnly: true
    })
  }

const remove =
  (_domain: string, prefix: string) =>
  (key: string, options?: CookieOptionsType) => {
    destroyCookie(null, `${prefix}-${key}`, options)
  }

const cleanAuth =
  (domain: string, prefix: string) => (options?: CookieOptionsType) => {
    remove(domain, prefix)('auth-key', options)
    remove(domain, prefix)('user', options)
    remove(domain, prefix)('company', options)
    remove(domain, prefix)('orb-selected', options)
  }

interface AppStorageProviderProps {
  cookieDomain: string
  cookiePrefix: string
}

export const AppStorageProvider = ({
  cookieDomain,
  cookiePrefix
}: AppStorageProviderProps) => ({
  get: get(cookieDomain, cookiePrefix),
  set: set(cookieDomain, cookiePrefix),
  remove: remove(cookieDomain, cookiePrefix),
  cleanAuth: cleanAuth(cookieDomain, cookiePrefix)
})
